// Sign-out unmounts the tree while the browser is still on its way to Auth0.
// Without this flag the boot splash would mount and flash the brand loader
// during what is really a teardown.
let signingOut = false;

export function markSigningOut(): void {
  signingOut = true;
}

export function isSigningOut(): boolean {
  return signingOut;
}
